<template>
  <div class="offline-banner-anchor">
    <transition
      name="banner-fade-slide"
      appear
    >
      <div
        v-if="!isOnline"
        class="offline-banner glass-surface flex items-start no-wrap"
        role="status"
        aria-live="polite"
      >
        <lucide-icon
          name="wifi-off"
          size="18px"
          color="brand-dark"
          class="offline-banner__icon flex-shrink"
          aria-hidden="true"
        />

        <div class="offline-banner__text">
          <div class="text-graph-primary-dark text-14 text-font-medium">You're offline</div>
          <div class="text-12 text-info">Showing saved data until you reconnect.</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { useOnlineStatus } from 'src/composables/app/system/useOnlineStatus'

  const { isOnline } = useOnlineStatus()
</script>

<style lang="scss">
  .offline-banner-anchor {
    position: fixed;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2000;
    max-width: min(92vw, 26rem);
    width: max-content;
    pointer-events: none;
  }

  .offline-banner {
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    pointer-events: auto;
  }

  .offline-banner__icon {
    margin-top: 0.125rem;
  }

  .offline-banner__text {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }
</style>
